module.exports = __webpack_public_path__ + "static/media/back-pc.285454d0.jpg";